module.exports = __webpack_public_path__ + "static/media/laptop2.1f8ba240.jpg";